import React from 'react';
import PropTypes from 'prop-types';

// The one segmented control this section uses: the recurrence mode (None / Manual / Scheduled),
// the daily Due choice and the On Save choice were three copies of the same row of buttons. The
// class names are unchanged -- style.css and the section's tests both key off
// .inspect-recurrence-mode and .inspect-mode-btn. `value` is compared by identity, so an
// options list of booleans (Keep / Recompute) works as well as one of strings.
var SegmentedToggle = function (props) {
  var options = props.options;
  var value = props.value;
  var onChange = props.onChange;
  var className =
    'inspect-recurrence-mode' +
    (props.inline ? ' inspect-recurrence-mode-inline' : '') +
    (props.hasError ? ' has-error' : '');

  return (
    <div className={className} role="group" aria-label={props.ariaLabel}>
      {options.map(function (option) {
        return (
          <button
            key={String(option.value)}
            type="button"
            className={'inspect-mode-btn' + (option.value === value ? ' active' : '')}
            onClick={function () { onChange(option.value); }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

SegmentedToggle.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  inline: PropTypes.bool,
  hasError: PropTypes.bool,
};

export default SegmentedToggle;
